import { contractValidators } from "../Contract/contractValidators";

export const rentalContractValidators = {
  ...contractValidators
};
